<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-file-text-o"></i>  Pedidos</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">

        <div class="col-9">
          <div class="input-group" style="margin-bottom: 10px">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
            <input type="text" class="form-control" id="myInput" @keyup.enter="getorders(1)" v-model="search" placeholder="Filtrar pedidos..." />
            <div class="input-group-append">
              <span class="input-group-text" @click="redirectURL('/admin/create_order')"><i class="fa fa-plus"></i></span>
            </div>
            <div class="input-group-append">
              <span class="input-group-text" @click="getorders(1)"><i class="fa fa-refresh"></i></span>
            </div>
          </div>
        </div>

        <div class="col-3">

          <select v-on:change="getorders(1)" class="form-control" v-model="status">
            <option value="">Todos</option>
            <option value="4">Em análise</option>
            <option value="1">Pagamento pendente</option>
            <option value="2">Pagamento confirmado</option>
            <option value="3">Pedido Cancelado</option>
          </select>

        </div>
        <div class="col-12">
          <table class="table table-bordered table-bordered" style="background: white">
            <thead>
            <tr>
              <th class="text-center" width="30">ID</th>
              <th class="text-center" scope="col" width="100">Data</th>
              <th scope="col">Cliente</th>
              <th class="text-center" scope="col">NF</th>
              <th scope="col" width="200">Status</th>
              <th class="text-center" scope="col" width="120">Valor</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in orders" v-bind:key="order.id">
              <td><a href="javascript:;" @click="redirectURL('/admin/order/'+order.id)">#{{order.id}}</a></td>
              <td><small>{{ order.date | formatDate }}</small></td>
              <td>
                  <small v-if="order.profile.person_or_company">{{order.profile.company_name}}</small>
                  <small v-else>{{order.profile.name}}</small>
              </td>
              <td class="text-center">{{ order.nfe }}</td>
              <td>
                <span :inner-html.prop="order.status | nameStatusOrder"></span>
                <span style="color: #761c19" v-show="order.status === 'Cancelado' && order.reason !== ''">/ Reprovado</span>
              </td>
              <td class="text-center">R$ {{ order.total | formatPrice }}</td>
            </tr>
            <tr v-show="!orders.length"><td colspan="6" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
          </table>
          <div class="pagination pagination-medium pagination-right">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getorders(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getorders(next)">Próxima</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <footer-admin/>
  </div>
</template>

<script>
  import order from "../../api/order"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  export default {
    name: "AdminOrders",
    mixins: [mixins],
    data () {
      return {
        orders: [],
        status: '',
        page: 1,
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState(['logged'])
    },
    methods: {
      getorders(page){
        this.page = page
        order.list(this.page, this.search, this.status).then((response)  =>  {
          this.orders = response.data.results
          this.treatPagination(page, response.data.count, response.data.pages)
        })
      }
    },
    activated(){
      this.getorders(this.page)
    },
    mounted(){
      this.getorders(this.page)
    }
  }
</script>

<style scoped>
  .jumbotron-fluid{
    padding-top: 100px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
</style>
